// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mEiA","rootNoMargin":"styles_rootNoMargin__3ASeg"};